(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('OrdineSearch', OrdineSearch);

    OrdineSearch.$inject = ['$resource'];

    function OrdineSearch($resource) {
        var resourceUrl =  'api/_search/ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
